import { useNavigate } from "react-router-dom";

export const TaxesRoutesComponent = () => {
	const navigate = useNavigate();
	const ArrayData = [
		// HEADING
		// {
		// 	label: "Remittance",
		// 	menuHeaderLabel: true,
		// },
		{
			label: "Remittance",
			items: [
				{
					label: "CRA",
					command: () => {
						navigate("/taxes/remittance/cra");
					},
				},
				{
					label: "CRA Credit",
					command: () => {
						navigate("/taxes/remittance/cra-credit");
					},
				},
				{
					label: "RQ",
					command: () => {
						navigate("/taxes/remittance/rq");
					},
				},]
		},

		// HEADING
		// {
		// 	label: "WCB/WSIB",
		// 	menuHeaderLabel: true,
		// },
		{
			label: "WCB/WSIB",
			items: [
				{
					label: "Ontario",
					item: [
						{
							label: "CU Code Setup",
							command: () => {
								navigate("/");
							},
						},
						{
							label: "Remittance",
							command: () => {
								navigate("/");
							},
						},
						{
							label: "Reconciliation",
							command: () => {
								navigate("/");
							},
						},
					],
				},
				{
					label: "Alberta",
					item: [
						{
							label: "Code Setup",
							command: () => {
								navigate("/");
							},
						},
						{
							label: "Remittance",
							command: () => {
								navigate("/");
							},
						},
					],
				},]
		},

		// HEADING
		// {
		// 	label: "EHT",
		// 	menuHeaderLabel: true,
		// },
		{
			label: "EHT",
			items: [{
				label: "Ontario",
				command: () => {
					navigate("/taxes/eht/ontario");
				},
			},
			{
				label: "British Columbia",
				command: () => {
					navigate("/taxes/eht/bc_eht");
				},
			},]
		}
	];

	return {
		TaxesRoutes: ArrayData,
	};
};
